<template>
  <v-dialog v-model="isShareComment" max-width="600" persistent>
    <v-card class="quick-view">
      <v-card-title class="font-weight-bold px-5">
        Chia sẻ nhận xét
        <v-icon aria-label="Close" @click="closeModal()">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pa-5">
        <p>Bạn có chắc chắn muốn chia sẻ nhận xét buổi học với phụ huynh học sinh? Nhận xét sẽ được hiển thị trên web và app gia sư khi bạn xác nhận!</p>
      </v-card-text>
      <v-card-actions class="pa-5 group-btn-comment">
        <v-btn @click="closeModal()" color="#E0E0E0">
          Hủy
        </v-btn>
        <v-btn color="error" @click="saveComment(itemReview)">
          Xác nhận
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="css" scoped>
.group-btn-comment {
  display: flex;
  float: right;
}
</style>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    isShareComment: {
      default: () => false,
    },
    itemReview: {
      type: Object,
      default: () => ({}),
    },
    subjectId: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      //
    };
  },
  created() {
    //
  },
  methods: {
    ...mapActions('student_care', ['sendComment']),
    closeModal() {
      this.$emit('closeModalShareComment');
    },
    async saveComment(itemReview) {
      const params = {
        id: itemReview.id,
        comment_content: itemReview.comment_content,
        publish_status: 1,
      };
      const res = await this.sendComment(params);
      if (!res) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra khi gửi và chia sẻ nhận xét cho học sinh!',
        });
        return;
      }
      this.$swal({
        type: 'success',
        title: 'Thành công!',
        text: 'Đã lưu và chia sẻ nhận xét!',
      }).then(() => {
        this.closeModal();
        Bus.$emit('close-edit-comment');
        Bus.$emit('load-right-data', { subjectId: this.subjectId });
        Bus.$emit('lesson-ieltsy');
      });
    },
  },
};
</script>
